import { render, staticRenderFns } from "./OfficeReturnAddress.vue?vue&type=template&id=2c192947&"
import script from "./OfficeReturnAddress.vue?vue&type=script&lang=ts&"
export * from "./OfficeReturnAddress.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports